import React, { useState, useEffect } from 'react';
import './OTPModal.css';
import Button from './common/Button';
import DelayedMaskInput from './common/DelayedMaskInput';
import useDialogA11y from '../hooks/useDialogA11y';

const OTPModal = ({
	isOpen = true,
	onClose = () => {},
	customDetails,
	mobileNumber = '',
	OTP = '',
	otpError = '',
	time = 60,
	isResend = false,
	verifySpinner = false,
	isVerifyDisabled = false,
	onOTPChange = () => {},
	onResendOtp = () => {},
	onVerifyOtp = () => {},
}) => {
	const [otpValue, setOtpValue] = useState(OTP);
	const dialogRef = useDialogA11y(isOpen, onClose);

	useEffect(() => {
		setOtpValue(OTP);
	}, [OTP]);

	const handleOTPChange = (value) => {
		setOtpValue(value);
		onOTPChange(value);
	};

	if (!isOpen) return null;

	return (
		<div className="otp-modal-backdrop">
			<div
				ref={dialogRef}
				className="otp-modal-content"
				role="dialog"
				aria-modal="true"
				aria-labelledby="otp-modal-title"
				style={{ width: '40%', margin: '0 auto' }}
			>
				<button
					type="button"
					className="otp-modal-close"
					onClick={onClose}
					aria-label="Close OTP dialog"
					style={{ minWidth: '24px', minHeight: '24px' }}
				>
					×
				</button>

				<h2
					id="otp-modal-title"
					className="otp-modal-title"
					style={{
						fontFamily: customDetails?.fontFamily,
						textAlign: 'left',
						color: 'black',
					}}
				>
					Verify mobile number
				</h2>

				<p
					className="otp-modal-subtitle"
					style={{
						fontFamily: customDetails?.fontFamily,
						textAlign: 'left',
					}}
				>
					Please enter the OTP sent to your registered mobile number
				</p>

				<label htmlFor="otp-modal-input" className="form-field-label">
					One-time password (OTP)
				</label>
				<DelayedMaskInput
					id="otp-modal-input"
					placeholder="Enter OTP"
					value={otpValue}
					maxLength={8}
					onChange={handleOTPChange}
					onEnter={(e) => {
						if (!isVerifyDisabled) {
							e.preventDefault();
							onVerifyOtp();
						}
					}}
					autoFocus
					className="otp-modal-input"
					aria-invalid={otpError ? 'true' : undefined}
					aria-describedby={otpError ? 'otp-modal-error' : undefined}
					style={{
						fontFamily: customDetails?.fontFamily,
						'--focus-color': customDetails?.primaryColor,
						width: '50%',
						display: 'block',
						marginLeft: 0,
						borderColor: otpError ? '#c62828' : undefined,
					}}
				/>
				{otpError && (
					<p id="otp-modal-error" className="form-field-error" role="alert">
						{otpError}
					</p>
				)}

				<div className="otp-modal-resend">
					<button
						type="button"
						onClick={onResendOtp}
						disabled={!isResend}
						aria-label="Resend OTP"
						className={`otp-modal-resend-btn ${
							isResend ? 'enabled' : 'disabled'
						}`}
						style={{
							color: isResend ? customDetails?.primaryBtnColor : '#6B6D6F',
							fontFamily: customDetails?.fontFamily,
						}}
					>
						Didn't receive OTP? Try Again
					</button>
					{time !== 60 && (
						<span
							className="otp-modal-timer"
							aria-live="polite"
							aria-atomic="true"
							style={{
								fontFamily: customDetails?.fontFamily,
							}}
						>
							in {time} sec
						</span>
					)}
				</div>

				<hr
					style={{
						width: '100%',
						marginLeft: 0,
						marginTop: 8,
						marginBottom: 16,
					}}
				/>

				<div className="otp-modal-actions">
					<Button
						onClick={onVerifyOtp}
						disabled={isVerifyDisabled}
						aria-busy={verifySpinner}
						aria-label={verifySpinner ? 'Verifying OTP' : 'Verify OTP'}
						style={{
							borderRadius: customDetails?.borderRadius,
							backgroundColor: isVerifyDisabled
								? '#949494'
								: customDetails?.primaryBtnColor,
							fontFamily: customDetails?.fontFamily,
							'--hover-color': '#3730A3',
						}}
					>
						{verifySpinner ? <div className="otp-modal-spinner" aria-hidden="true" /> : 'Verify'}
					</Button>
					<Button
						onClick={onClose}
						text="Cancel"
						color={customDetails?.primaryBtnColor}
						variant="outlined"
						borderColor={customDetails?.btnBorderColor}
						style={{
							borderRadius: customDetails?.borderRadius,
							fontFamily: customDetails?.fontFamily,
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default OTPModal;
